import request from '@/utils/request'

// 消息中心列表
export function mesList(data) {
  return request({
    url: 'api/messageCenter/queryList',
    method: 'get',
    params: data
  })
}

// 未读消息列表
export function getUnreadList(data) {
  return request({
    url: 'api/messageCenter/queryAllList',
    method: 'get',
    params: data
  })
}

// 消息中心列表
export function emptyMessage(data) {
  return request({
    url: 'api/messageCenter/empty',
    method: 'get',
    params: data
  })
}

// 添加消息
export function addMessage(data) {
  return request({
    url: 'api/messageCenter/insert',
    method: 'post',
    data: data
  })
}

// 删除消息
export function readById(data) {
  return request({
    url: 'api/messageCenter/readById',
    method: 'get',
    params: data
  })
}

